import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBriefcase,
  faBullseyeArrow,
  faCalendarCheck,
  faChartLine,
  faClipboardCheck,
  faDiagramSubtask,
  faFileLines,
  faFileSignature,
  faUser,
} from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import type { EntityPreviewEntityType } from "./types";

export const CHAT_ENTITY_CARD_ICON_CLASS = "h-3 w-3 shrink-0 text-slate-400 dark:text-slate-500";

/** Group container — visible but softer than a full workbench card. */
export const CHAT_ENTITY_CARD_SHELL_CLASS =
  "rounded-lg border border-slate-200/70 bg-slate-50/90 p-2 dark:border-slate-700/55 dark:bg-slate-800/45";

/** Candidate / detail row inside the shell. */
export const CHAT_ENTITY_CARD_CANDIDATE_BUTTON_CLASS =
  "flex w-full items-center gap-2 rounded-md border px-3 py-2.5 text-left transition-colors border-slate-200/65 bg-white/85 hover:border-slate-300/80 hover:bg-white dark:border-slate-700/55 dark:bg-slate-900/30 dark:hover:border-slate-600/65 dark:hover:bg-slate-900/45";

export const ENTITY_PREVIEW_RESOURCE_LABELS: Record<EntityPreviewEntityType, string> = {
  artifact: "Outputs",
  case_check: "Cases",
  client: "Clients",
  disclosure: "Disclosures",
  lead: "Leads",
  mission: "Workflows",
  meeting: "Meetings",
  portfolio: "Portfolios",
  product: "Funds",
  task: "Steps",
};

export const ENTITY_PREVIEW_ICONS: Record<EntityPreviewEntityType, IconDefinition> = {
  artifact: faFileLines,
  case_check: faClipboardCheck,
  client: faUser,
  disclosure: faFileSignature,
  lead: faUser,
  mission: faBullseyeArrow,
  meeting: faCalendarCheck,
  portfolio: faBriefcase,
  product: faChartLine,
  task: faDiagramSubtask,
};

